import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { MenuItem, Typography } from '@material-ui/core'
import { FormGroup } from '../../form/FormGroup'
import { ControlledTextField } from '../../form/ControlledTextField'
import { WizardStep, WizardStepProps } from '../../form/WizardStep'
import { FormValues as FullFormValues } from './form-values'
import { BuildingType } from '../../../generated/graphql'
import { validators } from '../../../validation/validators'

type FormValues = Pick<FullFormValues, 'name' | 'type' | 'multiplier'>

type Props = WizardStepProps<FullFormValues> & {
  onSubmit: (values: FormValues) => void
}

export function NameStep(props: Props): React.ReactElement {
  const { defaultValues, onSubmit } = props

  const { control, handleSubmit, errors } = useForm<FormValues>({
    defaultValues,
  })
  const { t } = useTranslation()

  return (
    <WizardStep
      {...props}
      title={t('createBuilding.pages.name.title')}
      onSubmit={handleSubmit(onSubmit)}
    >
      <FormGroup>
        <ControlledTextField
          control={control}
          name="name"
          rules={validators.required}
          error={errors.name}
          type="name"
          label={t('createBuilding.pages.name.name')}
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="type"
          rules={validators.required}
          error={errors.type}
          label={t('createBuilding.pages.name.type')}
          select
        >
          {Object.values(BuildingType).map((type) => (
            <MenuItem key={type} value={type}>
              {t(`buildingType.${type}`)}
            </MenuItem>
          ))}
        </ControlledTextField>
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="multiplier"
          rules={{ ...validators.required, ...validators.positiveInteger }}
          error={errors.multiplier}
          type="number"
          label={t('createBuilding.pages.name.multiplier')}
          defaultValue="1"
          InputProps={{
            startAdornment: <Typography>x</Typography>,
          }}
        />
      </FormGroup>
    </WizardStep>
  )
}
